// @ts-nocheck
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";

const ButtonContainer = styled.button `
    display: flex;
    position: relative;
    flex-direction: column;
    padding: 0;
    min-width: 600px;
    width: 45%;
    height: 200px;
    margin: 5px;
    border: 2px solid black;

    @media screen and (max-width: 576px) {
        width: 70%;
        height: 100px;
    }

    & img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: top;
        transition: object-position 0.3s ease;
    }

    &:hover {
        border: 2px solid gold;
    }

    &:hover img {
        object-position: 25% 75%;
    }

    & .styled_img_text {
        position: absolute;
        top: 50%;
        left: 0%;
        transform: translate(-50%, -50%);
        color: white; /* Colore del testo */
        background-color: rgba(0, 0, 0, 0.5); /* Sfondo semi-trasparente */
        padding: 5px 10px;
        border-radius: 5px;
        text-align: center;
    }

    &:hover .styled_img_text {
        opacity: 1;
    }
`

function ButtonCategoryComponent(props) {

    return(
        <ButtonContainer 
         className='button-category-component'
         onClick={props.onClick}
        >
            <div className="styled_img_text">
                {props.title}
            </div>
            <img 
                src={process.env.REACT_APP_STORAGE_URL + props.img}
                alt={props.img + "_alt"}
            >
            </img>
        </ButtonContainer>  
    )
}

export default ButtonCategoryComponent;